let supportsPassive

try {
  const opts = Object.defineProperty({}, `passive`, {
    get() {
      supportsPassive = true
      return undefined
    },
  })
  window.addEventListener(`test`, null, opts)
} catch (e) {
  supportsPassive = false
}

export function setTouchEvent(add, el, eventType, callback, options) {
  return el[`${add ? `add` : `remove`}EventListener`](
    `touch${eventType}`,
    callback,
    supportsPassive ? { passive: true, ...options } : false,
  )
}

export function addTouchEvent(el, type, callback, options) {
  return setTouchEvent(true, el, type, callback, options)
}

export function removeTouchEvent(el, type, callback, options) {
  return setTouchEvent(false, el, type, callback, options)
}
